<template>
  <button class="spush-page-back-button" @click="$emit('click')">
    <div class="spush-page-back-button__icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none">
        <g clip-path="url(#clip0_1_31)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.707 8.98041C13.8945 9.16794 13.9998 9.42224 13.9998 9.68741C13.9998 9.95257 13.8945 10.2069 13.707 10.3944L11.586 12.5154L13.707 14.6364C13.8947 14.8239 14.0002 15.0783 14.0002 15.3436C14.0003 15.6088 13.8951 15.8633 13.7075 16.0509C13.52 16.2385 13.2657 16.344 13.0004 16.3441C12.7351 16.3442 12.4807 16.2389 12.293 16.0514L9.46404 13.2224C9.27657 13.0349 9.17126 12.7806 9.17126 12.5154C9.17126 12.2502 9.27657 11.9959 9.46404 11.8084L12.293 8.98041C12.4806 8.79294 12.7349 8.68762 13 8.68762C13.2652 8.68762 13.5195 8.79294 13.707 8.98041Z" />
        </g>
        <defs>
          <clipPath id="clip0_1_31">
            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0.515381)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="spush-page-back-button__text">{{ $t('spush_page__go_back') }}</div>
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss">
.spush-page-back-button {
  border: unset;
  outline: unset;
  background: unset;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: unset;

  &:hover,
  &:focus {
    .spush-page-back-button__text {
      color: var(--spush-second-color);
    }

    .spush-page-back-button__icon g path {
      fill: var(--spush-second-color);
    }
  }

  @media (hover: none) {
    cursor: auto;
    &:hover {
      .spush-page-back-button__text {
        color: var(--spush-main-color);
      }

      .spush-page-back-button__icon g path {
        fill: var(--spush-main-color);
      }
    }
  }

  &__icon {
    height: 24px;

    g {
      path {
        fill: var(--spush-main-color);
        transition: 0.3s;
      }
    }
  }

  &__text {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--spush-main-color);
    transition: 0.3s;
    margin-left: 4px;
    height: 18px;
  }
}
</style>
